<template>
  <div>
    <div v-for="(group, index) in groupedTimeEntries" :key="index">
      <list-group :date="group.group" :time-entries="group.values" :showUser="showUser"/>
    </div>
  </div>
</template>

<script>
  import ListGroup from './ListGroup.vue'
  import { date } from 'quasar'
  import { groupBy } from 'src/utils/array'
  import { parseDateTime } from 'src/utils/date'

  export default {
    props: {
      timeEntries: {
        type: Array,
        required: true
      },

      showUser: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      groupedTimeEntries () {
        return groupBy(this.timeEntries, timeEntry => {
          return date.formatDate(parseDateTime(timeEntry.started_at.date), 'YYYY-MM-DD')
        })
      }
    },

    components: {
      ListGroup
    }
  }
</script>
